import { Editor } from "slate";

import ImageUploadCallback from "../type/ImageUploadCallback";

import { insertImageFiles } from "./withImages";

const selectImage = (editor: Editor, onImageUpload: ImageUploadCallback) => {
  const input = document.createElement("input");
  input.type = "file";
  input.multiple = false;
  input.onchange = () => {
    if (input.files) {
      insertImageFiles(editor, onImageUpload, input.files);
    }
  };
  input.click();
};

export default selectImage;
